import { render, staticRenderFns } from "./FunnelSessionDesktop.vue?vue&type=template&id=97b94f72&scoped=true"
import script from "./FunnelSessionDesktop.vue?vue&type=script&lang=js"
export * from "./FunnelSessionDesktop.vue?vue&type=script&lang=js"
import style0 from "./FunnelSessionDesktop.vue?vue&type=style&index=0&id=97b94f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b94f72",
  null
  
)

export default component.exports